package meineglasfaser.frontend.www.pages.portal.auth

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.navigation.Anchor
import io.ktor.client.plugins.*
import io.ktor.http.*
import meineglasfaser.api.routes.AuthRoutes.RealmCustomerPortal.Login
import meineglasfaser.frontend.common.BackendApi
import meineglasfaser.frontend.common.components.widgets.Toast
import meineglasfaser.frontend.common.components.widgets.Toasts
import meineglasfaser.frontend.common.components.yaform.YaForm
import meineglasfaser.frontend.common.components.yaform.YaFormButton
import meineglasfaser.frontend.common.components.yaform.YaFormTextInput
import meineglasfaser.frontend.common.setJsonBody
import meineglasfaser.frontend.common.withAuth
import meineglasfaser.frontend.common.withExistingParams
import meineglasfaser.frontend.www.components.CustomerState
import meineglasfaser.frontend.www.components.CustomerStateRedirectIfLoggedIn
import meineglasfaser.frontend.www.components.GlobalCustomerState
import org.jetbrains.compose.web.attributes.ButtonType
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.dom.*

@Page
@Layout(".components.layouts.ShopLayout")
@Composable
fun LoginPage(ctx: PageContext) {
    CustomerStateRedirectIfLoggedIn()

    Div(attrs = { classes("auth-form")}) {
        H1(attrs = { classes("text-center") }) {
            Text("Anmeldung")
        }
        YaForm(
            onSubmitScope = { data ->
                val body = Login.RequestBody(
                    email = data.string(Login.RequestBody::email),
                    password = data.string(Login.RequestBody::password),
                )
                BackendApi.post(Login()) {
                    withAuth()
                    setJsonBody(body)
                }.fold(
                    onSuccess = {
                        GlobalCustomerState.value = CustomerState.Indeterminate
                        Toasts.display(
                            Toast.success("Erfolgreich angemeldet")
                        )
                        val redirectUrl = ctx.route.params["redirect"]
                        if (redirectUrl != null) {
                            ctx.router.navigateTo(redirectUrl)
                        } else {
                            ctx.router.navigateTo("/kundenportal/overview")
                        }
                    },
                    onFailure = { error ->
                        when (error) {
                            is ClientRequestException -> when (error.response.status) {
                                HttpStatusCode.BadRequest -> {
                                    Toasts.display(
                                        Toast.error("Bitte E-Mail und Passwort angeben")
                                    )
                                }
                                HttpStatusCode.Unauthorized -> {
                                    Toasts.display(
                                        Toast.error("E-Mail und/oder Passwort falsch")
                                    )
                                }
                                else -> {
                                    Toasts.display(
                                        Toast.error("Unerwarteter Fehler: ${error.response.status}")
                                    )
                                }
                            }
                        }
                    }
                )
            }
        ) {
            P(attrs = { classes("text-center") }) {
                Span { Text("Sie haben noch kein Konto? ") }
                val href = ctx.route.withExistingParams("/kundenportal/auth/register")
                Anchor(href) {
                    Text("Hier registrieren")
                }
            }
            YaFormTextInput(
                prop = Login.RequestBody::email,
                label = { Text("E-Mail") },
                type = InputType.Email,
                required = true,
            )
            YaFormTextInput(
                prop = Login.RequestBody::password,
                label = { Text("Passwort") },
                type = InputType.Password,
                required = true,
            )
            Div({ classes("grid") }) {
                P({ classes("text-end") }) {
                    val href= ctx.route.withExistingParams("/kundenportal/auth/forgot/stage1")
                    Anchor(href) {
                        Text("Passwort vergessen?")
                    }
                }
            }
            YaFormButton(type = ButtonType.Submit) {
                Text("Anmelden")
            }
        }
    }
}
